var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-outbox"},[_c('div',{ref:"box",staticClass:"my-inbox"},_vm._l((_vm.sendVal),function(item,index){return _c('div',{key:index,ref:"list",refInFor:true,staticClass:"my-list",style:(_vm.note),on:{"click":function($event){return _vm.clickItem(index)}}},[_c('span',{staticClass:"my-uname"},[_vm._v(_vm._s(item.content))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }